import { observable, makeObservable, runInAction } from "mobx";
import { FooterType } from "../../old/Types/FooterType";
import footerApi from "../Api/FooterApi";

class FooterStore {
	dataFooter: FooterType | undefined;

	constructor() {
		makeObservable(this, {
			dataFooter: observable,
		});
		footerApi().then((data) => {
			runInAction(() => {
				this.dataFooter = data;
			});
		});
	}
}

export default new FooterStore();
